import * as React from 'react';

import { Document } from '../../components/Document';
import { useSelector } from 'react-redux';
import { documentSelector, linksSelector } from './utils/selectors';

export function DocumentContainer() {
  const document = useSelector(documentSelector);
  const links = useSelector(linksSelector);

  if (!document) {
    return null;
  }

  return <Document document={document} links={links} />;
}
